<script lang="ts" setup>    
import { ref } from 'vue';


</script>

<template>
    <div>
        <router-view></router-view>
    </div>
</template>